import { jsx as t, jsxs as r, Fragment as he } from "react/jsx-runtime";
import { withManagedProps as S } from "@made-people/managed-props";
import { withZod as m } from "@made-people/react-prop-guard";
import { createContext as me, useState as w, useContext as be, useEffect as O } from "react";
import { useNewsletterMethod as ge } from "@made-people/grease-newsletter";
import { z as s } from "zod";
import { inputFieldStyling as Z, termsAndConditionsStyling as Ne, signupListsStyling as ye, errorStyling as ve, newsletterTemplate1Styling as we, newsletterTemplate2Styling as z, newsletterTemplate3Styling as q, newsletterTemplate4Styling as I } from "./index-blueprint.es.js";
import { useTranslate as A } from "@made-people/grease-translations";
import * as T from "@radix-ui/react-checkbox";
import { AnimatePresence as L, motion as g } from "motion/react";
import { Button as xe } from "@made-people/blueprint-button";
import { componentWrapperSchema as x, ComponentWrapper as V } from "@made-people/blueprint-component-wrapper";
import { badgeSchema as G, Badge as J } from "@made-people/blueprint-badge";
import { responsiveImageSchema as K, ResponsiveImage as Q } from "@made-people/blueprint-responsive-image";
import "@made-people/blueprint";
const Se = (n) => {
  if (n.length === 0)
    return;
  const o = /^[\d+\-()\s]+$/.test(n), c = /\d/.test(n);
  if (!(o && c))
    return "Newsletter_Invalid_Phone_Number";
  const e = n.replace(/\D/g, "").length;
  if (e < 7 || e > 15)
    return "Newsletter_Invalid_Phone_Number";
}, ke = s.union([
  s.string(),
  s.array(s.string()),
  s.function().args(s.custom()).returns(s.union([s.string(), s.array(s.string())]))
]), Ke = s.object({
  listId: ke.optional(),
  requiresCheckbox: s.boolean().optional(),
  children: s.custom()
}), U = me(void 0), X = (n) => {
  const { loading: o, error: c, setError: e, execute: l } = ge("subscribe"), [a, d] = w(!n.requiresCheckbox), [p, i] = w(!1), [u, h] = w(""), [b, de] = w(""), [D, F] = w(void 0), R = (v) => {
    de(v), D && F(void 0);
  }, pe = s.string().email().safeParse(u).success && a, ue = {
    error: c,
    phoneError: D,
    loading: o,
    checked: a,
    subscribed: p,
    setChecked: d,
    emailAddress: u,
    setEmailAddress: h,
    phoneNumber: b,
    setPhoneNumber: R,
    handleSubmit: async (v) => {
      if (v == null || v.preventDefault(), !a) {
        const f = new Error("Newsletter_Method_Agree");
        throw e(f), f;
      }
      const $ = Se(b);
      if ($) {
        F($);
        return;
      }
      if (F(void 0), pe) {
        if (typeof n.listId == "function")
          throw new Error("listId getter function isn't implemented yet");
        await l({
          email: u,
          attributes: {
            listId: n.listId,
            phoneNumber: b || void 0
          }
        }).then(() => {
          i(!0), h(""), R(""), F(void 0);
        }).catch(() => i(!1)).finally(() => {
          setTimeout(() => {
            i(!1);
          }, 5e3);
        });
      }
    }
  };
  return /* @__PURE__ */ t(U.Provider, { value: ue, children: n.children });
};
X.displayName = "FormStateProvider";
const N = () => {
  const n = be(U);
  if (!n)
    throw new Error("useFormState must be used inside a <FormStateProvider />");
  return n;
}, k = s.object({
  heading: s.string().optional(),
  headingTag: s.enum(["h3", "h4", "h5", "h6"]).optional(),
  className: s.string().optional()
}), W = m(k, (n) => {
  const { heading: o, headingTag: c, className: e } = n;
  if (!o)
    return null;
  const l = A();
  return /* @__PURE__ */ t(c || "h3", { className: e, children: /* @__PURE__ */ t("span", { children: l(o) }) });
}), C = s.object({
  text: s.string().optional(),
  className: s.string().optional()
}), y = m(C, (n) => {
  const { text: o, className: c } = n;
  return o ? /* @__PURE__ */ t("p", { className: c, children: o }) : null;
}), H = s.object({
  floatingLabel: s.string().optional(),
  placeholder: s.string().optional(),
  variants: s.custom().optional(),
  styling: s.custom().optional().describe("If you want to override the default styling")
}), P = m(H, (n) => {
  const { emailAddress: o, setEmailAddress: c, subscribed: e } = N(), a = (n.styling ?? Z).styles(n.variants), d = A(), p = (u) => {
    const h = u.target.value;
    c && c(h);
  };
  O(() => {
    e && c("");
  }, [e, c]);
  let i = "";
  return n.floatingLabel ? i = "" : n.placeholder ? i = d(n.placeholder) : i = "", /* @__PURE__ */ r("div", { className: a.inputWrapper, children: [
    /* @__PURE__ */ t(
      "input",
      {
        id: "email",
        onChange: p,
        value: o,
        type: "email",
        placeholder: i,
        className: a.inputField
      }
    ),
    n.floatingLabel && /* @__PURE__ */ t("label", { htmlFor: "email", className: a.inputLabel, children: d(n.floatingLabel) })
  ] });
}), Y = () => /* @__PURE__ */ t(L, { children: /* @__PURE__ */ t(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    fill: "none",
    width: "16",
    height: "16",
    strokeWidth: 2,
    viewBox: "0 0 24 24",
    children: /* @__PURE__ */ t(
      g.path,
      {
        initial: { pathLength: 0 },
        animate: { pathLength: 1 },
        exit: { pathLength: 0 },
        transition: {
          type: "tween",
          duration: 0.2,
          ease: "easeIn"
        },
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M4.5 12.75l6 6 9-13.5"
      }
    )
  }
) }), ee = s.object({
  text: s.string().optional(),
  checkIcon: s.custom().optional(),
  requireCheckbox: s.boolean().optional(),
  variants: s.custom().optional(),
  styling: s.custom().optional().describe("If you want to override the default styling")
}), j = m(ee, (n) => {
  const { setChecked: o, checked: c } = N(), l = (n.styling ?? Ne).styles(n.variants), a = n.checkIcon ?? /* @__PURE__ */ t(Y, {});
  return n.text ? /* @__PURE__ */ r("div", { className: l.termsAndConditionsWrapper, children: [
    n.requireCheckbox && /* @__PURE__ */ t(
      T.Root,
      {
        className: l.checkbox,
        id: "checkbox",
        onCheckedChange: () => o(!c),
        children: /* @__PURE__ */ t(T.Indicator, { className: l.checkboxIndicator, children: a })
      }
    ),
    /* @__PURE__ */ t("label", { htmlFor: "checkbox", className: l.termsAndConditionsBody, children: /* @__PURE__ */ t(
      "span",
      {
        dangerouslySetInnerHTML: {
          __html: n.text
        }
      }
    ) })
  ] }) : null;
}), te = s.object({
  lists: s.array(s.string()).optional(),
  variants: s.custom().optional(),
  checkIcon: s.custom().optional()
}), E = m(te, (n) => {
  const { setChecked: o, checked: c } = N();
  if (!n.lists)
    return null;
  const e = ye.styles(n.variants), l = n.checkIcon ?? /* @__PURE__ */ t(Y, {});
  return /* @__PURE__ */ t("div", { className: e.checkbox, children: n.lists.map((a) => /* @__PURE__ */ r("div", { className: e.checkbox, children: [
    /* @__PURE__ */ t(
      T.Root,
      {
        className: e == null ? void 0 : e.checkbox,
        id: `checkbox-${a}`,
        onCheckedChange: () => o(!c),
        checked: c,
        children: /* @__PURE__ */ t(T.Indicator, { className: e == null ? void 0 : e.checkboxIndicator, children: l })
      }
    ),
    /* @__PURE__ */ t("label", { htmlFor: `checkbox-${a}`, className: e == null ? void 0 : e.label, children: a })
  ] }, a)) });
}), Ce = s.object({
  error: s.custom().optional(),
  variants: s.custom().optional(),
  errorIcon: s.custom().optional()
}), Fe = m(Ce, (n) => {
  const o = ve.styles(n.variants);
  return /* @__PURE__ */ t(he, { children: n.error && /* @__PURE__ */ t("div", { className: o.wrapper, children: /* @__PURE__ */ t("p", { className: o.body, children: n.error.message }) }) });
}), ne = s.object({
  body: s.string().optional(),
  className: s.string().optional()
}), B = m(
  ne,
  (n) => {
    if (!n.body)
      return null;
    const o = A();
    return /* @__PURE__ */ t("p", { className: n.className, children: o(n.body) });
  }
), se = s.object({
  buttonLabel: s.string().optional(),
  buttonIcon: s.custom().optional(),
  className: s.string().optional(),
  variants: s.custom().optional(),
  confetti: s.boolean().optional()
}), _ = m(
  { schema: se, defaultProps: { confetti: !1 } },
  (n) => {
    const { loading: o, handleSubmit: c, subscribed: e } = N(), l = n.confetti && e;
    return /* @__PURE__ */ t("div", { className: n.className, children: /* @__PURE__ */ t(
      xe,
      {
        as: "button",
        label: n.buttonLabel,
        onClick: c,
        progress: o ? "loading" : "default",
        variants: n.variants,
        confetti: l
      }
    ) });
  }
), M = s.object({
  className: s.string().optional(),
  termsAndConditions: ee.optional(),
  inputField: H.optional(),
  phoneNumberField: H.optional(),
  submitButton: se.optional(),
  subscriptionSuccess: ne.optional(),
  lists: te.optional()
}), ie = s.object({
  variants: s.custom().optional(),
  template: s.literal("template1").optional(),
  heading: k.optional(),
  text: C.shape.text.optional(),
  form: M.optional()
}), Ie = S(
  "NewsletterTemplate1",
  m(ie, ({ variants: n, heading: o, text: c, form: e }) => {
    const l = we.styles(n), { subscribed: a, error: d } = N();
    return /* @__PURE__ */ r("section", { className: l.base, children: [
      /* @__PURE__ */ t(W, { className: l.heading, ...o }),
      /* @__PURE__ */ t(y, { className: l.body, text: c }),
      !a && /* @__PURE__ */ r("form", { className: l.form, children: [
        /* @__PURE__ */ r("div", { className: l.inputWrapper, children: [
          /* @__PURE__ */ t(P, { ...e == null ? void 0 : e.inputField }),
          /* @__PURE__ */ t(
            _,
            {
              className: l.buttonWrapper,
              ...e == null ? void 0 : e.submitButton
            }
          )
        ] }),
        /* @__PURE__ */ t(j, { ...e == null ? void 0 : e.termsAndConditions }),
        /* @__PURE__ */ t(E, { ...e == null ? void 0 : e.lists }),
        /* @__PURE__ */ t(Fe, { error: d })
      ] }),
      a && /* @__PURE__ */ t(B, { ...e == null ? void 0 : e.subscriptionSuccess })
    ] });
  })
), ae = s.object({
  variants: s.custom().optional(),
  template: s.literal("template2").optional(),
  heading: k.optional(),
  text: C.shape.text.optional(),
  form: M.optional(),
  layout: x.shape.layout.optional()
}), Te = S(
  "NewsletterTemplate2",
  m(
    ae,
    ({ variants: n, heading: o, text: c, form: e, layout: l }) => {
      const a = z.main.styles(n), { subscribed: d, error: p } = N(), i = {
        initial: { y: 20, opacity: 0 },
        animate: {
          y: 0,
          opacity: 1,
          transition: {
            type: "spring",
            stiffness: 300,
            damping: 15,
            mass: 0.5
          }
        },
        exit: {
          y: 20,
          opacity: 0,
          transition: {
            duration: 0.15,
            ease: [0.68, -0.55, 0.27, 1.55],
            type: "tween"
          }
        }
      };
      return /* @__PURE__ */ t(
        V,
        {
          className: a.wrapper,
          background: a.background,
          layout: l,
          children: /* @__PURE__ */ r("div", { className: a.container, children: [
            /* @__PURE__ */ t("div", { className: a.headingWrapper, children: /* @__PURE__ */ t(W, { className: a.heading, ...o }) }),
            /* @__PURE__ */ r("div", { className: a.formWrapper, children: [
              /* @__PURE__ */ r(L, { mode: "wait", children: [
                p && /* @__PURE__ */ t(g.div, { ...i, children: /* @__PURE__ */ t(y, { className: a.body, text: p.message }) }, "error"),
                d && !p && /* @__PURE__ */ t(g.div, { ...i, children: /* @__PURE__ */ t(
                  B,
                  {
                    className: a.body,
                    ...e == null ? void 0 : e.subscriptionSuccess
                  }
                ) }, "success"),
                !d && !p && /* @__PURE__ */ t(g.div, { ...i, children: /* @__PURE__ */ t(y, { className: a.body, text: c }) }, "text")
              ] }),
              /* @__PURE__ */ r("form", { className: a.form, children: [
                /* @__PURE__ */ r("div", { className: a.fieldsWrapper, children: [
                  /* @__PURE__ */ t(
                    P,
                    {
                      styling: z.inputField,
                      ...e == null ? void 0 : e.inputField
                    }
                  ),
                  /* @__PURE__ */ t(
                    _,
                    {
                      className: a.buttonWrapper,
                      ...e == null ? void 0 : e.submitButton
                    }
                  )
                ] }),
                /* @__PURE__ */ t(
                  j,
                  {
                    styling: z.termsAndConditions,
                    ...e == null ? void 0 : e.termsAndConditions
                  }
                ),
                /* @__PURE__ */ t(E, { ...e == null ? void 0 : e.lists })
              ] })
            ] })
          ] })
        }
      );
    }
  )
), le = s.object({
  variants: s.custom().optional(),
  template: s.literal("template3").optional(),
  heading: k.optional(),
  text: C.shape.text.optional(),
  form: M.optional(),
  badge: G.optional(),
  image: K.optional(),
  layout: x.shape.layout.optional()
}).merge(x), Ae = S(
  "NewsletterTemplate3",
  m(
    le,
    ({ variants: n, heading: o, text: c, form: e, badge: l, image: a, layout: d, ...p }) => {
      const i = q.main.styles(n), { subscribed: u, error: h } = N(), b = {
        initial: { y: 20, opacity: 0 },
        animate: {
          y: 0,
          opacity: 1,
          transition: {
            type: "spring",
            stiffness: 300,
            damping: 15,
            mass: 0.5
          }
        },
        exit: {
          y: 20,
          opacity: 0,
          transition: {
            duration: 0.15,
            ease: [0.68, -0.55, 0.27, 1.55],
            type: "tween"
          }
        }
      };
      return /* @__PURE__ */ r(
        V,
        {
          className: i.wrapper,
          background: i.background,
          layout: { ...d },
          ...p,
          children: [
            /* @__PURE__ */ r("div", { className: i.container, children: [
              /* @__PURE__ */ r("div", { className: i.headingWrapper, children: [
                (l == null ? void 0 : l.label) && /* @__PURE__ */ t(J, { ...l, className: i.badge }),
                /* @__PURE__ */ t(W, { className: i.heading, ...o })
              ] }),
              /* @__PURE__ */ r("div", { className: i.formWrapper, children: [
                /* @__PURE__ */ r(L, { mode: "wait", children: [
                  h && /* @__PURE__ */ t(g.div, { ...b, children: /* @__PURE__ */ t(y, { className: i.body, text: h.message }) }, "error"),
                  u && !h && /* @__PURE__ */ t(g.div, { ...b, children: /* @__PURE__ */ t(
                    B,
                    {
                      className: i.body,
                      ...e == null ? void 0 : e.subscriptionSuccess
                    }
                  ) }, "success"),
                  !u && !h && /* @__PURE__ */ t(g.div, { ...b, children: /* @__PURE__ */ t(y, { className: i.body, text: c }) }, "text")
                ] }),
                /* @__PURE__ */ r("form", { className: i.form, children: [
                  /* @__PURE__ */ r("div", { className: i.fieldsWrapper, children: [
                    /* @__PURE__ */ t(
                      P,
                      {
                        styling: q.inputField,
                        ...e == null ? void 0 : e.inputField
                      }
                    ),
                    /* @__PURE__ */ t(
                      _,
                      {
                        className: i.buttonWrapper,
                        ...e == null ? void 0 : e.submitButton
                      }
                    )
                  ] }),
                  /* @__PURE__ */ t(
                    j,
                    {
                      styling: q.termsAndConditions,
                      ...e == null ? void 0 : e.termsAndConditions
                    }
                  ),
                  /* @__PURE__ */ t(E, { ...e == null ? void 0 : e.lists })
                ] })
              ] })
            ] }),
            /* @__PURE__ */ t(
              Q,
              {
                ...a,
                displaySize: (a == null ? void 0 : a.displaySize) ?? {
                  mobile: "50vw",
                  tablet: "30vw",
                  desktop: "30vw"
                },
                className: i.image
              }
            )
          ]
        }
      );
    }
  )
), Le = s.object({
  floatingLabel: s.string().optional(),
  placeholder: s.string().optional(),
  variants: s.custom().optional(),
  styling: s.custom().optional().describe("If you want to override the default styling")
}), We = m(Le, (n) => {
  const { phoneNumber: o, setPhoneNumber: c, subscribed: e, phoneError: l } = N(), d = (n.styling ?? Z).styles(n.variants), p = A(), i = (h) => {
    const b = h.target.value;
    c && c(b);
  };
  O(() => {
    e && c("");
  }, [e, c]);
  let u = "";
  return n.floatingLabel ? u = "" : n.placeholder ? u = p(n.placeholder) : u = "", /* @__PURE__ */ r("div", { className: d.inputWrapper, children: [
    /* @__PURE__ */ t(
      "input",
      {
        id: "phoneNumber",
        onChange: i,
        value: o,
        type: "tel",
        placeholder: u,
        "aria-invalid": !!l,
        className: d.inputField
      }
    ),
    n.floatingLabel && /* @__PURE__ */ t("label", { htmlFor: "phoneNumber", className: d.inputLabel, children: p(n.floatingLabel) }),
    l && /* @__PURE__ */ t("p", { role: "alert", className: d.inputError, children: p(l) })
  ] });
}), oe = s.object({
  variants: s.custom().optional(),
  template: s.literal("template4").optional(),
  heading: k.optional(),
  text: C.shape.text.optional(),
  form: M.optional(),
  badge: G.optional(),
  image: K.optional(),
  layout: x.shape.layout.optional()
}).merge(x), Pe = S(
  "NewsletterTemplate4",
  m(
    oe,
    ({ variants: n, heading: o, text: c, form: e, badge: l, image: a, layout: d, ...p }) => {
      const i = I.main.styles(n), { subscribed: u, error: h } = N(), b = {
        initial: { y: 20, opacity: 0 },
        animate: {
          y: 0,
          opacity: 1,
          transition: {
            type: "spring",
            stiffness: 300,
            damping: 15,
            mass: 0.5
          }
        },
        exit: {
          y: 20,
          opacity: 0,
          transition: {
            duration: 0.15,
            ease: [0.68, -0.55, 0.27, 1.55],
            type: "tween"
          }
        }
      };
      return /* @__PURE__ */ r(
        V,
        {
          className: i.wrapper,
          background: i.background,
          layout: { ...d },
          ...p,
          children: [
            /* @__PURE__ */ r("div", { className: i.container, children: [
              /* @__PURE__ */ r("div", { className: i.headingWrapper, children: [
                (l == null ? void 0 : l.label) && /* @__PURE__ */ t(J, { ...l, className: i.badge }),
                /* @__PURE__ */ t(W, { className: i.heading, ...o })
              ] }),
              /* @__PURE__ */ r("div", { className: i.formWrapper, children: [
                /* @__PURE__ */ r(L, { mode: "wait", children: [
                  h && /* @__PURE__ */ t(g.div, { ...b, children: /* @__PURE__ */ t(y, { className: i.body, text: h.message }) }, "error"),
                  u && !h && /* @__PURE__ */ t(g.div, { ...b, children: /* @__PURE__ */ t(
                    B,
                    {
                      className: i.body,
                      ...e == null ? void 0 : e.subscriptionSuccess
                    }
                  ) }, "success"),
                  !u && !h && /* @__PURE__ */ t(g.div, { ...b, children: /* @__PURE__ */ t(y, { className: i.body, text: c }) }, "text")
                ] }),
                /* @__PURE__ */ r("form", { className: i.form, children: [
                  /* @__PURE__ */ r("div", { className: "flex flex-col gap-4", children: [
                    /* @__PURE__ */ t("div", { className: i.fieldsWrapper, children: /* @__PURE__ */ t(
                      P,
                      {
                        styling: I.inputField,
                        ...e == null ? void 0 : e.inputField
                      }
                    ) }),
                    (e == null ? void 0 : e.phoneNumberField) && /* @__PURE__ */ t("div", { className: i.fieldsWrapper, children: /* @__PURE__ */ t(
                      We,
                      {
                        styling: I.inputField,
                        ...e.phoneNumberField
                      }
                    ) }),
                    /* @__PURE__ */ t("div", { className: i.buttonWrapper, children: /* @__PURE__ */ t(_, { ...e == null ? void 0 : e.submitButton }) })
                  ] }),
                  /* @__PURE__ */ t(
                    j,
                    {
                      styling: I.termsAndConditions,
                      ...e == null ? void 0 : e.termsAndConditions
                    }
                  ),
                  /* @__PURE__ */ t(E, { ...e == null ? void 0 : e.lists })
                ] })
              ] })
            ] }),
            /* @__PURE__ */ t(
              Q,
              {
                ...a,
                displaySize: (a == null ? void 0 : a.displaySize) ?? {
                  mobile: "50vw",
                  tablet: "30vw",
                  desktop: "30vw"
                },
                className: i.image
              }
            )
          ]
        }
      );
    }
  )
), ce = s.union([
  ie,
  ae,
  le,
  oe
]), re = m(
  ce,
  (n) => {
    switch (n.template) {
      case "template1":
        return /* @__PURE__ */ t(Ie, { ...n });
      case "template2":
        return /* @__PURE__ */ t(Te, { ...n });
      case "template3":
        return /* @__PURE__ */ t(Ae, { ...n });
      case "template4":
        return /* @__PURE__ */ t(Pe, { ...n });
      default:
        return null;
    }
  }
);
re.displayName = "NewsletterTemplateSelector";
const je = "template2", Ee = ce, Qe = S(
  "NewsletterSignup",
  m(
    {
      schema: Ee,
      defaultProps: {
        template: "template2"
      }
    },
    (n) => /* @__PURE__ */ t(X, { children: /* @__PURE__ */ t(re, { ...n || { template: je } }) })
  )
), Ue = () => /* @__PURE__ */ t(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    fill: "none",
    width: "16",
    height: "16",
    strokeWidth: 2,
    viewBox: "0 0 24 24",
    children: /* @__PURE__ */ t(
      "path",
      {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M4.5 12.75l6 6 9-13.5"
      }
    )
  }
);
export {
  Y as AnimatedCheckIcon,
  Ue as CheckIcon,
  U as FormStateContext,
  X as FormStateProvider,
  W as Heading,
  P as InputField,
  Qe as NewsletterSignup,
  Ie as NewsletterTemplate1,
  Te as NewsletterTemplate2,
  Ae as NewsletterTemplate3,
  Pe as NewsletterTemplate4,
  re as NewsletterTemplateSelector,
  We as PhoneNumberField,
  E as SignupLists,
  _ as SubmitButton,
  B as SubscriptionSuccess,
  j as TermsAndConditions,
  y as Text,
  Fe as ValidationError,
  Ce as errorSchema,
  M as formSchema,
  Ke as formStateProviderSchema,
  k as headingSchema,
  H as inputFieldSchema,
  ke as listIdSchema,
  Ee as newsletterSignupPropsSchema,
  ie as newsletterTemplate1Schema,
  ae as newsletterTemplate2Schema,
  le as newsletterTemplate3Schema,
  oe as newsletterTemplate4Schema,
  ce as newsletterTemplateSelector,
  Le as phoneNumberFieldSchema,
  te as signupListsSchema,
  se as submitButtonSchema,
  ne as subscriptionSuccessSchema,
  ee as termsAndConditionsSchema,
  C as textSchema,
  N as useFormState
};
//# sourceMappingURL=index.es.js.map
